


























































































































































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputAuthor } from '@/components/molecules/InputAuthor'
import { InputSubject } from '@/components/molecules/InputSubject'
import { InputCompleteWorks } from '@/components/molecules/InputCompleteWorks'
import { InputPublisher } from '@/components/molecules/InputPublisher'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import InputSeries from '@/components/molecules/InputSeries/InputSeries.vue'
import { AuthoritySearchType } from '@/types'

export interface InputAuthoritySearchItem {
  searchType: AuthoritySearchType
  author: {
    input: string
    no: string
    errorMessage: string
  }
  subject: {
    input: string
    no: string
    errorMessage: string
  }
  series: {
    input: string
    no: string
    errorMessage: string
  }
  completeWorks: {
    input: string
    no: string
    errorMessage: string
  }
  contentAuthor: {
    input: string
    no: string
    errorMessage: string
  }
  publisher: {
    input: string
    no: string
    errorMessage: string
  }
}

export const defaultInputAuthoritySearchItem = (): InputAuthoritySearchItem => ({
  searchType: AuthoritySearchType.Author,
  author: {
    input: '',
    no: '',
    errorMessage: ''
  },
  subject: {
    input: '',
    no: '',
    errorMessage: ''
  },
  series: {
    input: '',
    no: '',
    errorMessage: ''
  },
  completeWorks: {
    input: '',
    no: '',
    errorMessage: ''
  },
  contentAuthor: {
    input: '',
    no: '',
    errorMessage: ''
  },
  publisher: {
    input: '',
    no: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputSeries,
    InputAuthor,
    InputSubject,
    InputCompleteWorks,
    InputPublisher,
    InputDatePicker
  }
})
export default class BibliographyAuthoritySearch extends ComponentVue {
  @Ref()
  author!: InputAuthor

  @Ref()
  subject!: InputSubject

  @Ref()
  series!: InputSeries

  @Ref()
  completeWorks!: InputCompleteWorks

  @Ref()
  contentAuthor!: InputAuthor

  @Ref()
  publisher!: InputPublisher

  @Prop({ type: Boolean, default: false })
  tooliOnly!: boolean

  @PropSync('input', {
    type: Object
  })
  inputItem!: InputAuthoritySearchItem

  get authoritySearchType(): any {
    return AuthoritySearchType
  }

  focus(): void {
    this.$nextTick(() => {
      switch (this.inputItem.searchType) {
        case AuthoritySearchType.Author:
          this.author.textField.atomTextField.focus()
          break
        case AuthoritySearchType.Subject:
          this.subject.textField.atomTextField.focus()
          break
        case AuthoritySearchType.Series:
          this.series.textField.atomTextField.focus()
          break
        case AuthoritySearchType.CompleteWorks:
          this.completeWorks.textField.atomTextField.focus()
          break
        case AuthoritySearchType.ContentAuthor:
          this.contentAuthor.textField.atomTextField.focus()
          break
        case AuthoritySearchType.Publisher:
          this.publisher.textField.atomTextField.focus()
      }
    })
  }

  isDisabled(value: AuthoritySearchType): boolean {
    return value !== this.inputItem.searchType
  }

  @Emit('click:search')
  onClickSearch() {}

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
